import React from 'react';

import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { clearStaleSessionOnEntry } from './utils/entrySession';

// GRN-6623: propagate the CSP nonce (injected by the server into window.__CSP_NONCE__)
// to scripts webpack injects at runtime for lazily-loaded chunks. Runs before any
// dynamic import() executes (those happen during React render, well after this module).
// eslint-disable-next-line camelcase, no-undef
__webpack_nonce__ = typeof window !== 'undefined' ? window.__CSP_NONCE__ : undefined;

const rootDomElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootDomElement);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  reportWebVitals();
};

// GRN-7569: on an external-login entry (`?code=`), expire any stale customer-session cookie
// BEFORE the app's first API call. A dead `user_token` shadows a valid app token in the cookie
// resolver, which fails the configuration fetch and stops the app from booting at all — so the
// in-app cleanup (GRN-6811) never gets to run. See utils/entrySession.js.
// Always renders, whatever the outcome: a failed cleanup must not leave a blank page.
clearStaleSessionOnEntry().then(renderApp, renderApp);
